import Download from 'js-file-download'
import { PLAN_TYPES, PREMIUM_PLAN_ID, INVOICE_STATUSES } from '~/modules/billing/constants/common'
import contentDialog from '~/mixins/dialogs/contentDialog'
import successSnackbar from '~/modules/snackbar/mixins/successSnackbar'
import { isSafari } from '~/services/_utils/utils'
import premiumTrial from '~/modules/onboarding/mixins/premiumTrial'

const actions = {
  mixins: [contentDialog, successSnackbar, premiumTrial],
  data() {
    return {
      updateToPremiumLoading: false,
      purchaseLoading: false,
      cardLoading: false,
      balanceLoading: false
    }
  },
  computed: {
    actions() {
      return [
        {
          name: 'download',
          text: 'Download',
          icon: 'arrow-download',
          call: invoice => this.downloadInvoice(invoice)
        },
        {
          name: 'payByCard',
          text: 'Pay by card',
          icon: 'card',
          visible: invoice => [INVOICE_STATUSES.created].includes(invoice.status),
          call: invoice => this.payByCard(invoice.id)
        },
        {
          name: 'payByBalance',
          text: 'Pay from balance ',
          icon: 'wallet',
          visible: invoice => [INVOICE_STATUSES.created].includes(invoice.status),
          call: invoice => this.payByBalance(invoice.id)
        }
      ]
    }
  },
  methods: {
    async updateToPremium(shouldRedirect = false) {
      try {
        this.updateToPremiumLoading = true
        if (this.$Organization?.canActivateTrial) {
          await this.activatePremiumTrial({ updateDashboard: true })
        } else if (shouldRedirect) {
          this.$router.push({ name: 'billing', query: { to: 'plans' } })
        } else {
          await this.purchase(PLAN_TYPES.tariff)
        }
      } catch (e) {
        this.$handlers.error(e, this)
      } finally {
        this.updateToPremiumLoading = false
      }
    },
    async purchase(type, count) {
      try {
        this.purchaseLoading = true
        const payload = {
          type
        }
        if (type === PLAN_TYPES.tariff) {
          payload.tariffId = PREMIUM_PLAN_ID
        } else {
          payload.count = count
        }
        const invoiceId = this._.get(
          await this.$store.dispatch('billing/purchase', { payload }),
          'invoiceId',
          null
        )
        await this.contentDialog.open({
          width: '512px',
          component: 'billing-payment-form',
          componentProps: {
            invoiceId,
            type
          }
        })
      } catch (e) {
        this.$handlers.error(e, this)
      } finally {
        this.purchaseLoading = false
      }
    },
    async payByCard(invoiceId) {
      try {
        this.cardLoading = true
        if (isSafari) {
          const paymentWindow = window.open('', '_blank')
          const { url } = await this.$store.dispatch('invoices/payByCard', invoiceId)
          if (paymentWindow) {
            paymentWindow.location.href = url
          } else {
            window.location.href = url
          }
        } else {
          const { url } = await this.$store.dispatch('invoices/payByCard', invoiceId)
          window.open(url, '_blank')
        }
      } catch (e) {
        this.$handlers.error(e, this)
      } finally {
        this.cardLoading = false
      }
    },
    async payByBalance(invoiceId, isPlanPayment = false) {
      try {
        this.balanceLoading = true
        await this.$store.dispatch('invoices/payByBalance', invoiceId)
        await this.$store.dispatch('billing/getDashboardData')
        await this.$store.dispatch('billing/getConsumptions')
        if (isPlanPayment) {
          await this.$store.dispatch('organizations/read', this.$Organization?.id)
        }
        await this.successSnackbar.open({
          text: this.$t('Balance has charged successfully')
        })
      } catch (e) {
        this.$handlers.error(e, this)
      } finally {
        this.balanceLoading = false
      }
    },
    async downloadInvoice(invoice) {
      try {
        const blob = await this.$store.dispatch('invoices/payByBank', invoice?.id)
        if (blob) {
          Download(blob, `invoice-${invoice.number}.pdf`)
        }
      } catch (e) {
        this.$handlers.error(e, this)
      }
    }
  }
}

export default actions
